import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import React from "react";

const WhatsAppButton = () => {
  const phoneNumber = "919972529464"; // Replace with actual number
  const whatsappLink = `https://wa.me/${phoneNumber}`;

  // 👇 Force FaWhatsapp into a valid React component
  const Icon = FaWhatsapp as unknown as React.FC<{ size?: number }>;

  return (
    <motion.a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-6 bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4 }}
    >
      <Icon size={24} />
    </motion.a>
  );
};

export default WhatsAppButton;
